import request from "@/utils/request";

export function get_home(data){
    if(data=='china')
        return request({url:`${process.env.VUE_APP_URL_HOME_SERVICE}/home`,method:'get'});
}
